import { lazy } from "react";
import {
  HiOutlineCog,
  HiOutlineGift,
  HiOutlineSupport,
  HiOutlineUsers,
  HiOutlineViewGrid,
} from "react-icons/hi";
import { PiNotepadThin } from "react-icons/pi";
import { TbBrandSamsungpass } from "react-icons/tb";
import { VscGitPullRequestGoToChanges } from "react-icons/vsc";
const Dashboard = lazy(() => import("@/pages/Dashboard"));
const Offers = lazy(() => import("@/pages/Offers"));
const Users = lazy(() => import("@/pages/Users"));
const Login = lazy(() => import("@/pages/Signin"));
const Profile = lazy(() => import("@/pages/Profile"));
const OfferRequest = lazy(() => import("@/pages/OfferRequest"));
const PromoRequest = lazy(() => import("@/pages/PromoRequest"));
const Notifications = lazy(() => import("@/pages/Notifications"));
const Support = lazy(() => import("@/pages/Support"));
const Cms = lazy(() => import("@/pages/Cms"));
const UserDetail = lazy(() => import("@/pages/Users/UserDetail"));
const OfferDetail = lazy(() => import("@/pages/Users/OfferDetail"));
const Brands = lazy(() => import("@/pages/Cruds/Brands"));

export const routes = [
  {
    title: "Dashboard",
    exact: true,
    path: "/",
    showInSidebar: true,
    protected: true,
    icon: <HiOutlineViewGrid size={20} />,
    element: <Dashboard />,
  },
  {
    title: "Users",
    exact: true,
    path: "/users",
    showInSidebar: true,
    protected: true,
    icon: <HiOutlineUsers size={20} />,
    element: <Users />,
  },
  {
    title: "User Detail",
    exact: true,
    path: "/users/:id",
    showInSidebar: false,
    protected: true,
    icon: <HiOutlineUsers size={20} />,
    element: <UserDetail />,
  },

  {
    title: "Offers",
    exact: true,
    path: "/offers",
    showInSidebar: true,
    protected: true,
    icon: <HiOutlineGift size={20} />,
    element: <Offers />,
  },
  {
    title: "Offer Detail",
    exact: true,
    path: "user/offers/:id",
    showInSidebar: false,
    protected: true,
    icon: <HiOutlineGift size={20} />,
    element: <OfferDetail />,
  },
  {
    title: "Login",
    exact: true,
    path: "/login",
    showInSidebar: false,
    protected: false,
    element: <Login />,
  },
  {
    title: "Profile",
    exact: true,
    path: "/settings",
    protected: true,
    showInSidebar: true,
    icon: <HiOutlineCog size={20} />,
    element: <Profile />,
  },
  {
    title: "Offer Request",
    exact: true,
    path: "/offers/:id",
    protected: true,
    showInSidebar: false,
    icon: <VscGitPullRequestGoToChanges size={20} />,
    element: <OfferRequest />,
  },
  {
    title: "Promo Request",
    exact: true,
    path: "/promos",
    protected: true,
    showInSidebar: true,
    icon: <VscGitPullRequestGoToChanges size={20} />,
    element: <PromoRequest />,
  },
  {
    title: "Support",
    exact: true,
    path: "/support",
    protected: true,
    showInSidebar: true,
    icon: <HiOutlineSupport size={20} />,
    element: <Support />,
  },
  {
    title: "Brands",
    exact: true,
    path: "/brands",
    protected: true,
    showInSidebar: true,
    icon: <TbBrandSamsungpass size={20} />,
    element: <Brands />,
  },
  {
    title: "Notifications",
    exact: true,
    path: "/notifications",
    protected: true,
    showInSidebar: false,
    element: <Notifications />,
  },
  {
    title: "CMS",
    exact: true,
    path: "/cms",
    protected: true,
    showInSidebar: true,
    icon: <PiNotepadThin size={20} />,
    element: <Cms />,
  },
];
